import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03a21257"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["checked", "disabled"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "switch__round" }, null, -1))
const _hoisted_3 = { class: "switch__main-sign" }
const _hoisted_4 = { class: "switch__hint-sign" }

import { computed, ref, useSlots, watch } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'tir-toggle',
  props: {
    modelValue: { type: Boolean },
    isDisabled: { type: Boolean },
    isReverseSigns: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;

const slots = useSlots()

/**
 * Есть ли слот для лейбла
 */
const isLeft = computed(() => slots && slots.mainSign && slots.mainSign())





let localState = ref(props.modelValue)

watch(() => props.modelValue, () => {
  localState.value = !!props.modelValue;
});

/** Состояние кнопки */

/** Обработка клика на кнопку */
const OnClick = () => {
  emit('update:modelValue', !props.modelValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["switch", {
    'switch--reverse': props.isReverseSigns
  }])
  }, [
    _createElementVNode("label", {
      class: _normalizeClass(["switch__box", {
        'switch__box--disabled': props.isDisabled
      }])
    }, [
      _createElementVNode("input", {
        onClick: OnClick,
        type: "checkbox",
        checked: _unref(localState),
        disabled: props.isDisabled
      }, null, 8, _hoisted_1),
      _hoisted_2
    ], 2),
    (isLeft.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["switch__signs", {
    'switch__signs--reverse': props.isReverseSigns
  }])
        }, [
          _createElementVNode("span", _hoisted_3, [
            _renderSlot(_ctx.$slots, "mainSign")
          ]),
          _createElementVNode("span", _hoisted_4, [
            _renderSlot(_ctx.$slots, "hintSign")
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})